module.exports = __webpack_public_path__ + "img/gold3.4656ecae.png";